
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import {
  EnumHelper,
  SchoolEventTargetEnum,
  SchoolEventTypeEnum,
} from "@/constants/enum.constant";

@Component({
  components: {},
  filters,
})
export default class EventDetailItem2 extends Vue {
  @Prop({ default: null })
  private event!: any;
  @Prop({ default: null })
  private onDownload!: any;

  private types = EnumHelper(SchoolEventTypeEnum);

  private get isForAll() {
    return this.event?.target === SchoolEventTargetEnum.ALL;
  }
  private get isForCandidate() {
    return this.event?.target === SchoolEventTargetEnum.CANDIDATE;
  }
  private get isForCompany() {
    return this.event?.target === SchoolEventTargetEnum.COMPANY;
  }
}
